<template>
  <section :class="clases">
    <div class="gob-container">
      <slot />
    </div>
  </section>
</template>

<script>
/**
 * GobSection
 * Envoltorio de sección: fija el ritmo vertical y el ancho de medida comunes del sitio.
 */
const CLASE_TONO = {
  clara: 'bg-surface text-main',
  alterna: 'bg-surface-strong text-main',
  oscura: 'bg-surface-deep text-white',
  electrico: 'bg-electric text-white'
}

const CLASE_RITMO = {
  normal: 'py-16 md:py-20',
  amplio: 'py-20 md:py-28'
}

export default {
  name: 'GobSection',
  props: {
    tono: {
      type: String,
      default: 'clara',
      validator: (valor) => Object.keys(CLASE_TONO).includes(valor)
    },
    ritmo: {
      type: String,
      default: 'normal',
      validator: (valor) => Object.keys(CLASE_RITMO).includes(valor)
    }
  },
  computed: {
    clases() {
      return [CLASE_TONO[this.tono], CLASE_RITMO[this.ritmo]]
    }
  }
}
</script>
